import { Injectable } from '@angular/core';
import { ApiService, PagedRecords } from '../shared/api.service';

@Injectable()
export class DefaultService {
	getFundInfo(filter: Object, page: number = 1, size: number = 10, table: string): Promise<any> {
		const url = `${table}`;
		return this.apiService.getWithFilter(url, filter, page, size)
			.then(response => response as any);
	}
	findDefList(filter: Object, page: number = 1, size: number = 1000, table: string): Promise<PagedRecords> {
		return this.apiService.get(table)
			.then(response => response as PagedRecords);
	}
	serviceName = 'cop';
	dcfundService = 'cdb';
	holidayService = 'mrd';
	riskService = 'risk';
	jobServiceName = 'scheduler-common/';
	filter: Object = {};
	countries = '/commons/countrystates/list';
	currencies = '/commons/currencies';
	tpsService = 'tps'
	tpsIncAdapter = 'hub'
	tpsCoreAdapter = 'core'
	tpsSftp = 'sftp'
	tpsTransform = 'transform'
	tptInstruction = 'instruction'
	imageUrlPath = 'commons/stream'

	constructor(private apiService: ApiService) { }

	async find(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${table}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as PagedRecords;
	}
	
	async riskfind(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${this.riskService}/${table}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as PagedRecords;
	}
	
	async riskGet(filter: Object, page: number = 1, size: number = 10, query: string): Promise<any> {
		const url = `${this.serviceName}/${this.riskService}/${query}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as any;
	}
	
	async exportZip(filters: Object, page: number = 1, size: number = 10, query: string): Promise<any> {
		// const url = `${table}`;
		const url = `${this.serviceName}/${this.riskService}/${query}`
		const response = await this.apiService.commonExportWithFilter(url, filters);
		return response as any;
	}
	
	async holidayfind(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${this.holidayService}/${table}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as PagedRecords;
	}
	
	async dcfind(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${this.dcfundService}/${table}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as PagedRecords;
	}
	
	async getTrade(filter: Object, page: number = 1, size: number = 10, table: string): Promise<any> {
		const url = `${this.serviceName}/${table}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as any;
	}

	findOne(id: string, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${id}`;
		return this.apiService.get(url);
	}

	create(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}`;
		return this.apiService.post(url, data);
	}
	holidaycreate(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.holidayService}/${table}`;
		return this.apiService.post(url, data);
	}

	riskcreate(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.riskService}/${table}`;
		return this.apiService.post(url, data);
	}

	createJob(data: Object, query: string): Promise<Object> {
		const url = `${this.jobServiceName}${query}`;
		return this.apiService.post(url, data);
	}

	updateTd(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}`;
		return this.apiService.post(url, data);
	}

	createDc(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.post(url, data);
	}

	putupdateDc(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.post(url, data);
	}

	putDc(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.put(url, data);
	}

	putDcPosting(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.post(url, data);
	}

	putDcUpdate(data: any, table: string): Promise<Object> {
		const url = `${table}/${data['accountPostingDriver']}/${data['holidayDateAdjustment']}`;
		return this.apiService.post(url,data);
	}

	createCommons(data: Object, table: string): Promise<Object> {
		const url = 'commons/' + table;
		return this.apiService.post(url, data);
	}

	update(code: string, data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${code}/update`;
		return this.apiService.put(url, data);
	}

	risk_update(code: string, data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.riskService}/${table}/${code}`;
		return this.apiService.post(url, data);
	}

	update_(code: string, data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${code}`;
		return this.apiService.post(url, data);
	}

	riskupdate_(code: string, data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.riskService}/${table}/${code}`;
		return this.apiService.post(url, data);
	}

	createTrade(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.post(url, data);
	}

	updateTrade(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.post(url, data);
	}

	rerun(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}`;
		return this.apiService.post(url, data);
	}

	post(data: Object, table: string): Promise<Object> {
		const url = `${table}`;
		return this.apiService.post(url, data);
	}

	risk_Delete(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.riskService}/${table}`;
		return this.apiService.post(url, data);
	}

	put(data: Object, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}`;
			return this.apiService.put(url, data);
		} else {
			const url = `${this.serviceName}/${table}`;
			return this.apiService.put(url, data);
		}
	}

	postData(data: Object, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}`;
			return this.apiService.post(url, data);
		} else {
			const url = `${this.serviceName}/${table}`;
			return this.apiService.post(url, data);
		}
	}

	put_(data: Object, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}`;
			return this.apiService.post(url, data);
		} else {
			const url = `${this.serviceName}/${table}`;
			return this.apiService.post(url, data);
		}
	}

	delete(code: string, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}/${code}`;
			return this.apiService.delete(url);
		} else {
			const url = `${this.serviceName}/${table}/${code}`;
			return this.apiService.delete(url);
		}
	}

	delete_(code: string, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}/${code}`;
			return this.apiService.post(url);
		} else {
			const url = `${this.serviceName}/${table}/${code}`;
			return this.apiService.post(url);
		}
	}

	deleteroute_(code: string, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}/${code}/delete`;
			return this.apiService.post(url);
		} else {
			const url = `${this.serviceName}/${table}/${code}/delete`;
			return this.apiService.post(url);
		}
	}

	deleteTrade(code: string, table: string): Promise<Object> {
		const url = `${table}/${code}`;
		return this.apiService.post(url);
	}

	deleteCConfig(code: Object, table: string): Promise<Object> {
		if (table.includes('order')) {
			const url = `${table}`;
			return this.apiService.post_(url);
		} else {
			const url = `${this.serviceName}/${table}`;
			return this.apiService.post_(url, code);
		}
	}

	dcdelete(code: string, table: string): Promise<Object> {
		// if(table.includes('order')){
		const url = `${table}/${code}`;
		return this.apiService.post(url);
	}

	reconDelete(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/delete`;
		return this.apiService.post_(url, data);
	}
	
	holidayDelete(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.holidayService}/${table}/delete`;
		return this.apiService.post_(url, data);
	}

	async get(filter: Object, page: number = 1, size: number = 10, table: string): Promise<any> {
		const url = `${table}`;
		const response = await this.apiService.getWithFilter(url, filter, page, size);
		return response as any;
	}

	async getExecution(code: any, table: string): Promise<any> {
		const url = `${table}/${code['basketId']}/${code['fundCode']}`;
		const response = await this.apiService.getExecutionWithFilter(url);
		return response as any;
	}

	// =====To be change
	async reconSummaries(filter: Object, table: string): Promise<any> {
		const url = `${this.serviceName}/${table}`;
		const response = await this.apiService.getSummaries(url, filter);
		return response as any;
	}

	checkUploadFile(file: any): boolean {
		const re = /(\.(svg|img|png|jpg|jpeg))$/i;
		if (re.exec(file.name)) {
			return true;
		}
		return false;
	}

	getFormattedDate(date: any): string {
		const formattedDate = new Date(date);
		return formattedDate.getFullYear() + ('0' + (formattedDate.getMonth() + 1)).slice(-2) + ('0' + formattedDate.getDate()).slice(-2);
	}

	getStartDate(inputDate: Date) {
		const adjustedDate = this.adjustZone(inputDate);
		return JSON.stringify(adjustedDate).replace(/"/g, '');
	}

	getEndDate(inputDate: Date) {
		inputDate.setSeconds(24 * 60 * 60 - 1);
		return JSON.stringify(inputDate).replace(/"/g, '');
	}

	getStartOfTheDay(inputDate: Date) {
		inputDate.setSeconds(0);
		inputDate.setMinutes(0);
		inputDate.setHours(0);
		inputDate.setMilliseconds(0);
		return inputDate;
	}

	adjustZone(inputDate: Date) {
		const timeZone = new Date(inputDate);
		let UTCseconds;
		if (timeZone.getTimezoneOffset() > 0) {
			UTCseconds = (timeZone.getTime() + timeZone.getTimezoneOffset() * 60 * 1000);
		} else {
			UTCseconds = (timeZone.getTime() - timeZone.getTimezoneOffset() * 60 * 1000);
		}
		return new Date(UTCseconds);
	}

	getNewsletterPDFURL(data: any): string {
		return data['path'].split(data['path'].split('risk/newsletters/out/')[1])[0] + encodeURIComponent(data['path'].split('risk/newsletters/out/')[1]);
	}

	getNewsletterStreamUrl(data: { path: string }): string | null {
		if (!data?.path) return null;
		return this.apiService.getBaseAPIUrl() + this.imageUrlPath + '?url=' + encodeURIComponent(data.path);
	}

	mrd_update(code: string, data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${code}/update`;
		return this.apiService.post(url, data);
	}

	mrd_delete(code: string, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${code}/delete`;
		return this.apiService.post(url);
	}
	
	mrd_deleteAsset(code: string, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${code}`;
		return this.apiService.post(url);
	}

	risk_delete(code: string, table: string): Promise<Object> {
		const url = `${this.serviceName}/${table}/${code}`;
		return this.apiService.post(url);
	}

	//penterest hanges
	async mrdfind(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${this.holidayService}/${table}`;
		const response = await this.apiService.getWithFilterEn(url, filter, page, size);
		return response as PagedRecords;
	}

	async riskfindEn(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${this.riskService}/${table}`;
		const response = await this.apiService.getWithFilterEn(url, filter, page, size);
		return response as PagedRecords;
	}

	async riskgetEn(filter: Object, page: number = 1, size: number = 10, table: string): Promise<any> {
		const url = `${this.serviceName}/${this.riskService}/${table}`;
		const response = await this.apiService.getWithFilterEn(url, filter, page, size);
		return response as any;
	}

	async dcfindEn(filter: Object, page: number = 1, size: number = 10, table: string): Promise<PagedRecords> {
		const url = `${this.serviceName}/${this.dcfundService}/${table}`;
		const response = await this.apiService.getWithFilterEn(url, filter, page, size);
		return response as PagedRecords;
	}
	
	async dcgetEn(filter: Object, page: number = 1, size: number = 10, table: string): Promise<any> {
		const url = `${this.serviceName}/${this.dcfundService}/${table}`;
		const response = await this.apiService.getWithFilterEn(url, filter, page, size);
		return response as any;
	}

	createTPS(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsIncAdapter}/${table}`;
		return this.apiService.postTPS(url, data);
	}

	apiTPSCore(data: Object, table: string): Promise<any> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsCoreAdapter}/${table}`;
		return this.apiService.postTPS(url, data);
	}

	apiTPSInstruction(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tptInstruction}/${table}`;
		return this.apiService.postTPS(url, data);
	}

	apiTPSInstructions(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/instruction/${table}`;
		return this.apiService.postTPS(url, data);
	}

	apiTPSTransform(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsTransform}/${table}`;
		return this.apiService.postTPS(url, data);
	}
	
	async exportInstructionsTPS(data: Object, table: string): Promise<Blob> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tptInstruction}/${table}`;
		const response: any = await this.apiService.exportTPS(url, data);
		const blob = new Blob([response], { type: 'application/octet-stream' });
		return blob;
	}

	apiSFTPTPS(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsSftp}/${table}`;
		return this.apiService.postTPS(url, data);
	}

	async exportCoreTPS(data: Object, table: string): Promise<Blob> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsCoreAdapter}/${table}`;
		const response: any = await this.apiService.exportTPS(url, data);
		const blob = new Blob([response], { type: 'application/octet-stream' });
		return blob;
	}
	
	async exportCoreTPSGET(filters: Object, query: string): Promise<Blob> {
		const url = `${query}`;
		const response: any = await this.apiService.exportTPSGET(url, filters);
		const blob = new Blob([response], { type: 'application/octet-stream' });
		return blob;
	}

	apiTPSException(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${table}`;
		return this.apiService.postTPS(url, data);
	}
	
	apiTPSExceptionGet(data: Object, table: string): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${table}`;
		return this.apiService.get(url, data);
	}

	async exportTPS(data: Object, table: string): Promise<Blob> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsIncAdapter}/${table}`;
		const response: any = await this.apiService.exportTPS(url, data);
		const blob = new Blob([response], { type: 'application/octet-stream' });
		return blob;
	}

	fileUpload(data: Object, table: string,  headers:{}): Promise<Object> {
		const url = `${this.serviceName}/${this.tpsService}/${this.tpsIncAdapter}/${table}`;
		return this.apiService.uploadTPS(url, data, headers);
	}

	// getTPS(filter: Object, page: number = 1, size: number = 10, table: string): Promise<any> {
	// 	const url = `${this.serviceName}/${this.tpsService}/${this.tpsIncAdapter}/${table}`;
	// 	return this.apiService.getWithFilterTPS(url, filter, page, size)
	// 		.then(response => response as any);
	// }
}